import { createSlice } from "@reduxjs/toolkit";
import {    home_total_returnsThunk } from "./thunk";


export const initialState = {
  totalReturnsData: [],
  totalReturnsError: {
    code: null,
    message: '',
    data: null
  },
  totalReturnsLoading: false,
  
  
};

const Home_Total_Returns = createSlice({
  name: "Home_Total_Returns",
  initialState, 
  reducers: {}, 
  extraReducers: (builder) => {

    builder.addCase(home_total_returnsThunk.pending, (state) => {
      state.totalReturnsLoading = true ;
      state.totalReturnsError = initialState.totalReturnsError; 
  });
    builder.addCase(home_total_returnsThunk.fulfilled, (state, action) => {
        state.totalReturnsData = action.payload.data;
        state.totalReturnsLoading = false ;
    });
    builder.addCase(home_total_returnsThunk.rejected, (state, action) => {
      state.totalReturnsError = {
        code: action.payload?.code || null,
        message: action.payload?.message || "An unknown error occurred",
        data: action.payload?.data || null
      };
        state.totalReturnsLoading = false ;
    });
}
});

export const {
  apiRequest,
  apiError,
  
  
} = Home_Total_Returns.actions

export default Home_Total_Returns.reducer;